<div class="change-pw__wrapper">
    <div class="change-pw__title">
        <!-- mat-dialog-title -->
        <!-- style="
        min-height: 61px;
        min-width: 300px;
        /* padding-top: 8px; */
        padding: 0 50px;
        font-size: 16px;
        margin: 0px;
       " -->
        <span class="cls-modal-block-header">Сменить пароль</span>
        <div
            class="cls-icon-krest"
            *ngIf="!exitForm"
            [mat-dialog-close]="false"
        >
            <!-- <mat-icon svgIcon="krest" [mat-dialog-close]="false"></mat-icon> -->
            <img src="./assets/img/svg/cross.svg" alt="close" />
        </div>
    </div>
    <!-- mat-dialog-content -->
    <div class="change-pw__body">
        <form
            class="cls-change-form"
            [formGroup]="frm"
            [ngClass]="{ loader: loading }"
        >
            <ng-container
                *ngIf="!exitForm; then showForm; else showFormExit"
            ></ng-container>

            <ng-template #showForm>
                <div class="form-group w-100">
                    <label for="password1">Текущий пароль *</label>
                    <div class="input-wrapper">
                        <input
                            [type]="hidePasswordOLD ? 'password' : 'text'"
                            id="password1"
                            class="form-control"
                            formControlName="oldPW"
                            [readonly]="loading"
                            (blur)="onBlur('oldPW')"
                        />
                        <span
                            *ngIf="!hidePasswordOLD"
                            class="password-toggle"
                            (click)="hidePasswordOLD = !hidePasswordOLD"
                        >
                            <mat-icon svgIcon="visibility"></mat-icon>
                        </span>

                        <span
                            *ngIf="hidePasswordOLD"
                            class="password-toggle"
                            (click)="hidePasswordOLD = !hidePasswordOLD"
                        >
                            <mat-icon svgIcon="visibility_off"></mat-icon>
                        </span>
                    </div>
                </div>
                <div class="recovery-div">
                    <a
                        (click)="goToRecovery()"
                        [mat-dialog-close]="false"
                        class="cls-go-recovery"
                        title="Восстановление доступа к личному кабинету"
                        >Не помню пароль</a
                    >
                </div>
                <div class="form-group w-100">
                    <label for="password11">Новый пароль *</label>
                    <div class="input-wrapper">
                        <input
                            [type]="hidePasswordNEW ? 'password' : 'text'"
                            id="password11"
                            class="form-control"
                            formControlName="newPW"
                            [readonly]="loading"
                        />
                        <span
                            *ngIf="!hidePasswordNEW"
                            class="password-toggle"
                            (click)="hidePasswordNEW = !hidePasswordNEW"
                        >
                            <mat-icon svgIcon="visibility"></mat-icon>
                        </span>

                        <span
                            *ngIf="hidePasswordNEW"
                            class="password-toggle"
                            (click)="hidePasswordNEW = !hidePasswordNEW"
                        >
                            <mat-icon svgIcon="visibility_off"></mat-icon>
                        </span>
                    </div>
                </div>

                <div class="form-group w-100">
                    <label for="password12">Повтор нового пароля *</label>
                    <div class="input-wrapper">
                        <input
                            [type]="hidePasswordNEW2 ? 'password' : 'text'"
                            id="password12"
                            class="form-control"
                            formControlName="new2PW"
                            [readonly]="loading"
                        />
                        <span
                            *ngIf="!hidePasswordNEW2"
                            class="password-toggle"
                            (click)="hidePasswordNEW2 = !hidePasswordNEW2"
                        >
                            <mat-icon svgIcon="visibility"></mat-icon>
                        </span>

                        <span
                            *ngIf="hidePasswordNEW2"
                            class="password-toggle"
                            (click)="hidePasswordNEW2 = !hidePasswordNEW2"
                        >
                            <mat-icon svgIcon="visibility_off"></mat-icon>
                        </span>
                    </div>
                </div>
            </ng-template>

            <ng-template #showFormExit>
                <div class="contentExit">Пароль успешно изменен</div>
            </ng-template>

            <button
                class="btn btn-lg"
                *ngIf="!exitForm"
                [ngClass]="{
                    'cls-btn-send': frm.valid,
                    'cls-btn-send-disable': !testChangePW()
                }"
                type="submit"
                [disabled]="!testChangePW()"
                (click)="goToChange()"
            >
                Сменить
            </button>

            <button
                class="btn btn-lg w-100 cls-btn-second cls-btn-send"
                *ngIf="exitForm"
                type="submit"
                (click)="exit()"
                style="margin-bottom: 20px; margin-top: 50px"
            >
                Войти
            </button>
        </form>
    </div>
</div>
